export const parameters = {
    //backend : "https://app.theinfluenceroom.com",
    backend : `https://${window.location.hostname}:443`,
    recaptcha : "6LeYiVQqAAAAAOmVBqPp0e8798VjHa8cFITK9FcV",
    ai_backend : "https://platformai.theinfluenceroom.com"
}